import {
  NgModule,
  ModuleWithProviders,
  CUSTOM_ELEMENTS_SCHEMA
} from '@angular/core';

import { IgoPrintModule } from '@ximple/igo2-geo';
import { PrintToolComponent } from './print-tool/print-tool.component';

@NgModule({
  imports: [IgoPrintModule],
  declarations: [PrintToolComponent],
  exports: [PrintToolComponent],
  entryComponents: [PrintToolComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class IgoAppPrintModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: IgoAppPrintModule,
      providers: []
    };
  }
}
